import React, { useMemo } from 'react';
/** Material UI Packages. */
import { Box, FormControl, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';

/** Material UI Icons. */
import AddIcon from '@mui/icons-material/Add';
import UpdateIcon from '@mui/icons-material/Update';

/** Internal Components. */
import InputField from 'shared/ui/InputForm';
import ThemeButton from 'shared/ui/Button';
import { SelectField_delete } from 'shared/ui/SelectForm';

export default function ApplySettingController(props) {
    /** Get props from ApplySetting.js. */
    const {
        presetUIState,
        dispatch,
        applySettingData,
        presetNameInputRef,
        handlePresetList,
        handleAdd,
        handleDelete,
        handleUpdate,
    } = props;

    /** Destructure state. */
    const { mode, renderValue, presetName } = presetUIState;

    const sortedPresetOptions = useMemo(
        () => [...(applySettingData ?? [])].sort((a, b) => (a.name || '').localeCompare(b.name || '')),
        [applySettingData]
    );

    /** Handler to update preset name input field. */
    const handleInputField = (event) => {
        dispatch({
            type: 'SET_MULTIPLE',
            payload: { presetName: event.target.value },
        });
    };

    return (
        <Grid container spacing={3}>
            <Grid size={mode === 'note' ? 8 : 12}>
                <Box display="flex" justifyContent="space-between" alignContent="center">
                    <FormControl disabled={applySettingData.length === 0 || mode === 'create' || mode === 'edit'}>
                        <SelectField_delete
                            value={renderValue}
                            onChange={handlePresetList}
                            options={sortedPresetOptions}
                            disableDelete={mode !== 'note'}
                            handleDelete={handleDelete}
                        />
                    </FormControl>
                    {(mode === 'create' || mode === 'edit') && (
                        <Box sx={{ display: 'flex' }}>
                            <InputField
                                label="Name"
                                value={presetName}
                                onChange={handleInputField}
                                sx={{ gap: 0 }}
                                labelStyle={{ width: '48px' }}
                                inputStyle={{ width: '280px', fontSize: '13px', height: '25px' }}
                                inputRef={presetNameInputRef}
                                placeholder="Please enter the preset name."
                                maxLength={75}
                            />
                            {mode === 'create' ? (
                                <ThemeButton
                                    text="ADD"
                                    icon={<AddIcon />}
                                    disabled={presetName.trim() === ''}
                                    onClick={handleAdd}
                                    sx={{ ml: 1, px: 1, height: '25px' }}
                                    iconStyle={{ mr: 0.5 }}
                                />
                            ) : (
                                mode === 'edit' && (
                                    <ThemeButton
                                        text="UPDATE"
                                        icon={<UpdateIcon />}
                                        disabled={presetName.trim() === ''}
                                        onClick={handleUpdate}
                                        sx={{ ml: 1, px: 1, height: '25px' }}
                                        iconStyle={{ mr: 0.5 }}
                                    />
                                )
                            )}
                        </Box>
                    )}
                </Box>
            </Grid>
            {mode === 'note' && (
                <Grid size={4}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography sx={{ color: '#01354d', fontSize: '13px', fontWeight: 500, mb: 1 }}>
                            Note
                        </Typography>
                    </Box>
                </Grid>
            )}
        </Grid>
    );
}
